import { Form, Input, Modal, Select } from 'antd'
import { useEffect, useState } from 'react'
import { Scrollbars } from "react-custom-scrollbars-2"
import { reConstructionCategoryActions } from '../ReConstructionCategory/store/actions'
import { reMeasurementUnitActions } from '../ReMeasurementUnit/store/actions'
import CustomButton from "../../../components/CustomButton"
import CustomSelect from '../../../components/CustomSelect'
import { useDispatch, useSelector } from 'react-redux'
import { useDebounce } from "use-debounce"
import { useTranslation } from "react-i18next"
import './style.css'

const AddReConstructionCategoryModal = ({ create, visible, setVisible }) => {
	const [searchCategory, setSearchCategory] = useState(null)
	const [category] = useDebounce(searchCategory, 500)
	const [searchUnit, setSearchUnit] = useState(null)
	const [unit] = useDebounce(searchUnit, 500)
	const { changed, isSending, list } = useSelector(state => state.reConstructionCategoryReducer)
	const [form] = Form.useForm()
	const {t} = useTranslation(['common', 'valid', 'nri', 'action'])
	const dispatch = useDispatch()
	const pageSize = 10

	useEffect(() => {
		return () => {
			dispatch(reConstructionCategoryActions.clear())
			dispatch(reMeasurementUnitActions.clear())
		}
	}, [])

	useEffect(() => {
		if (unit?.length > 0){
			getUnits({
				name     : unit,
				pageSize : pageSize
			})
		}
	}, [unit])

	useEffect(() => {
		if (category?.length > 1){
			getCategories({
				name     : category,
				pageSize : pageSize
			})
		}
	}, [category])

	useEffect(() => {
		if (changed)
			handleCancel()
	}, [changed])

	const getCategories = (values) => {
		dispatch(reConstructionCategoryActions.getList(values))
	}

	const getUnits = (values) => {
		dispatch(reMeasurementUnitActions.getList(values))
	}

	const handleCancel = () => {
		setVisible(false)
		form.resetFields()
	}

	const add = (values) => {
		create({
			codeKKM  : values.codeKKM,
			name     : values.name,
			parentId : values.reConstructionCategory
		})
	}

	return (
		<Modal
			footer={[
				<CustomButton
					key="submit"
					loading={ isSending }
					type="green"
					onClick={() => form.validateFields().then(values => add(values))}
				>
					{t('action:add')}
				</CustomButton>
			]}
			title="Создание категории"
			open={ visible }
			width="1000px"
			onCancel={ handleCancel }
		>
			<Scrollbars
				autoHeight
				autoHide
				autoHeightMax={ 600 }
				height={ 600 }
			>
				<Form
					form={ form }
					labelCol={{	span: 8	}}
					name="Categories"
				>
					<Form.Item
						label={t('nri:categoryName')}
						name="name"
						rules={[{ required: true }]}
					>
						<Input.TextArea
							autoSize={{ minRows: 1,	maxRows: 3 }}
							placeholder={`${t('action:enter')} ${t('nri:categoryName').toLowerCase()}`}
						/>
					</Form.Item>
					<Form.Item
						label={t('nri:parentCategory')}
						name="reConstructionCategory"
						rules={[{ required: false }]}
					>
						<CustomSelect
							allowClear
							showSearch
							filterOption={ false }
							mode="single"
							notFoundContent={ null }
							placeholder="Введите категорию"
							onSearch={ (value) => setSearchCategory(value) }
						>
							{ list?.map((elem) => {
								return (
									<Select.Option
										key={ elem.id }
										title={ `${ elem.codeKKM } ${ elem.name }` }
										value={ elem.id }
									>
										{ `${ elem.codeKKM } ${ elem.name }` }
									</Select.Option>
								)
							}) }
						</CustomSelect>
					</Form.Item>
					<Form.Item
						label={t('nri:codeKKM')}
						name="codeKKM"
						rules={[{ required: true }]}
					>
						<Input.TextArea
							autoSize={{ minRows: 1,	maxRows: 3 }}
							placeholder={`${t('action:enter')} ${t('nri:codeKKM').toLowerCase()}`}
						/>
					</Form.Item>
				</Form>
			</Scrollbars>
		</Modal>
	)
}

export default AddReConstructionCategoryModal